import * as Yup from 'yup';
import { EMAIL_PATTERN_REGEX } from '../constants/common';

export const loginSchema = Yup.object({
  username: Yup.string()
    .matches(EMAIL_PATTERN_REGEX, 'Username is Invalid.')
    .required('Username is required.'),
  password: Yup.string().required('Password is required.')
});

export const forgotPasswordSchema = Yup.object({
  email: Yup.string()
    .matches(EMAIL_PATTERN_REGEX, 'Email Address is invalid.')
    .required('Email Address is required.')
});

export const resetPasswordSchema = Yup.object({
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(/^(?=.*[a-z]).*$/, 'Password must contain at least one lowercase letter.')
    .matches(/^(?=.*[A-Z]).*$/, 'Password must contain at least one uppercase letter.')
    .matches(/^(?=.*\d).*$/, 'Password must contain at least one digit.')
    .matches(
      /^(?=.*[!@#$%^&*()\-_=+{};:,<.>/?]).*$/,
      'Password must contain at least one special character.'
    )
    .matches(/^\S*$/, 'Password cannot contain spaces.'),
  confirmPassword: Yup.string()
    .required('Confirm Password is required.')
    .oneOf([Yup.ref('password'), null], 'Password does not match!!!')
});
